module.exports = __webpack_public_path__ + "img/Ellipse 148.9c448f9e.svg";